import { Component, Input, OnInit } from '@angular/core';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-contact-editor',
  templateUrl: './contact-editor.component.html',
  styleUrls: ['./contact-editor.component.scss']
})
export class ContactEditorComponent implements OnInit {
    @Input() contactForm: FormGroup;
    errorMatcher = new CustomErrorStateMatcher();

    constructor() { }

    get f() { return this.contactForm.controls; }

    ngOnInit() {
    }

}
